enum SideBarState {
  Default = 'default',
  Flag = 'flag',
  Rfi = 'rfi',
  CategoryOfVariance = 'category-of-variance',
  SafetyHazard = 'safety-hazard',
  Photo = 'photo',
  DeliveryCalendar = 'delivery-calendar',
  DeliveryDetails = 'delivery-details',
}

export default SideBarState
